import {SubAccount} from '@/subaccount/types/SubAccount'
import {IContextMenuItem} from '@tritt/multipanel'

type ExternalSubAccountSearch = {
    label: string,
    pre_query_url: string,
    post_query_url?: string,
    icon?: string,
    forceSearchByName?: boolean
}
//TODO: How to use custom icons in context menu items?
const SEARCH_ENGINES: ExternalSubAccountSearch[] = [
    {
        label: 'proff.no',
        pre_query_url: 'https://www.proff.no/bransjesøk/?q=',
        icon: 'i-ph-briefcase',
    },
    {
        label: 'Brønnøysundregistrene',
        pre_query_url: 'https://virksomhet.brreg.no/nb/oppslag/enheter?navn=',
        icon: 'i-ph-city',
    },
    {
        label: 'Google',
        pre_query_url: 'https://www.google.com/search?q=',
        icon: 'i-ph-google-logo'
    },
    {
        label: 'LinkedIn',
        pre_query_url: 'https://www.linkedin.com/search/results/all/?keywords=',
        icon: 'i-ph-linkedin-logo'
    },
    {
        label: '1881.no',
        pre_query_url: 'https://www.1881.no/?query=',
        icon: 'i-ph-magnifying-glass'
    },
    {
        label: 'Facebook',
        pre_query_url: 'https://www.facebook.com/search/top/?q=',
        icon: 'i-ph-facebook-logo'
    }
]

export const getExternalSubAccountSearchContextMenuItems = (subAccount: SubAccount): IContextMenuItem[] => {
    return SEARCH_ENGINES.map((engine) => {
        return {
            label: engine.label,
            icon: engine.icon,
            onSelect: () => {
                const query = subAccount.name || subAccount.orgNo
                if (subAccount && query) {
                    const url = `${engine.pre_query_url}${encodeURIComponent(query)}${engine.post_query_url || ''}`
                    window.open(url, '_blank')
                } else {
                    console.warn('Error occurred: Either subAccount or no name / orgNo', subAccount, {query})
                }
            }
        }
    })
}